import { Link } from 'react-router-dom';
import { heroMedia } from '../utils/mediaConfig.js';

const OilGas = () => (
  <>
  <section className="relative h-[820px] tablet:px-6 tablet:h-auto tablet:min-h-[560px]">
    <video autoPlay muted loop playsInline preload="metadata" poster={heroMedia.oilGas.poster} aria-hidden="true" className="absolute inset-0 w-full h-full object-cover">
      <source src={heroMedia.oilGas.video} type="video/mp4" />
    </video>
    <div className="absolute inset-0 [background:linear-gradient(90deg,_rgba(7,9,53,0.97)_0%,_rgba(7,9,53,0.8)_50%,_rgba(7,9,53,0.25)_100%)]">
    </div>
    <div className="relative pt-[240px] px-[120px] pb-0 max-w-[920px] flex flex-col gap-7 tablet:pt-[124px] tablet:px-6 tablet:pb-16">
      <p className="m-0 text-[16px] text-mx-accent-light tracking-[0.04em] font-display">
        Oil & Gas
      </p>
      <h1 className="m-0 font-medium text-[76px] leading-[1.04] tracking-[-0.02em] font-display tablet:text-[44px] tablet:leading-[1.08]">
        Perforating and completion components, machined to your print
      </h1>
      <p className="m-0 text-[20px] leading-[1.6] text-mx-copy max-w-[680px]">
        Gun carriers, endplates, feedthroughs and the parts around them, produced at qualified partner plants and delivered duty-paid to your facility.
      </p>
      <div className="flex gap-4 mt-2 phone:flex-wrap">
        <Link to="/contact" className="mx-button">
          Send us your drawing
        </Link>
        <Link to="#og-products" className="mx-button-outline">
          See components
        </Link>
      </div>
    </div>
  </section>
  <section id="og-products" className="pt-[140px] px-[120px] pb-0 flex flex-col gap-12 tablet:px-6">
    <h2 className="m-0 font-medium text-[52px] leading-[1.1] max-w-[760px] font-display tablet:text-[32px]">
      Components we supply
    </h2>
    <div className="grid [grid-template-columns:repeat(3,_minmax(0,_1fr))] gap-6 tablet:[grid-template-columns:1fr]">
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/gun-carrier-scallop-milling.jpg" alt="Perforating gun carrier in a CNC mill with scallops being machined" loading="lazy" className="h-[220px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Gun carriers and housings
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Scalloped and slick carriers in the lengths, diameters and shot densities you specify.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/subs-bulkheads.jpg" alt="Machined subs and bulkhead adapters" loading="lazy" className="h-[220px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Bulkheads and subs
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Pressure-rated connections machined for clean, repeatable make-up between guns.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/endplates-tandems.jpg" alt="Machined end caps and tandem couplings" loading="lazy" className="h-[220px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Endplates and tandems
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Turned and milled end components held to the tolerances on your drawing.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/feedthroughs.jpg" alt="Hermetic feedthroughs and connectors" loading="lazy" className="h-[220px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Feedthroughs and connectors
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Electrical feedthroughs and contact assemblies, inspected lot by lot.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/charge-cases-liners.jpg" alt="Drawn steel cases and copper liners" loading="lazy" className="h-[220px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Charge cases and liners
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Deep-drawn and formed components supplied to your charge design.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/export-crates.jpg" alt="Export crates and pallets ready to ship" loading="lazy" className="h-[220px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Kitting and packaging
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Custom crating and labeling so parts arrive protected and ready to stage.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="mt-40 p-[120px] bg-mx-panel border-t border-mx-border border-b border-mx-border grid [grid-template-columns:repeat(2,_minmax(0,_1fr))] gap-20 tablet:px-6 tablet:mx-4 tablet:[grid-template-columns:1fr]">
    <div className="flex flex-col gap-6 tablet:min-w-0">
      <h2 className="m-0 font-medium text-[48px] leading-[1.1] font-display tablet:text-[32px]">
        A second source that shows up on time
      </h2>
      <p className="m-0 text-[18px] leading-[1.6] text-mx-copy">
        Most service companies already buy these parts. We give your supply chain another qualified source, with the delivery and paperwork handled by a U.S. company.
      </p>
    </div>
    <ul className="m-0 p-0 list-none flex flex-col tablet:min-w-0">
      <li className="py-6 px-0 border-t border-mx-border flex flex-col gap-1.5">
        <strong className="text-[20px] font-semibold font-display">
          Duty-paid to your yard
        </strong>
        <span className="text-[16px] leading-[1.6] text-mx-muted">
          Tariffs, customs entry and freight are in the price. No surprise invoices.
        </span>
      </li>
      <li className="py-6 px-0 border-t border-mx-border flex flex-col gap-1.5">
        <strong className="text-[20px] font-semibold font-display">
          Traceable material
        </strong>
        <span className="text-[16px] leading-[1.6] text-mx-muted">
          Mill test reports traced to heat number, in the alloy grade you specify.
        </span>
      </li>
      <li className="py-6 px-0 border-t border-mx-border flex flex-col gap-1.5">
        <strong className="text-[20px] font-semibold font-display">
          Inspection data with every lot
        </strong>
        <span className="text-[16px] leading-[1.6] text-mx-muted">
          CMM and in-process records, so incoming inspection goes faster.
        </span>
      </li>
      <li className="py-6 px-0 border-t border-mx-border border-b border-mx-border flex flex-col gap-1.5">
        <strong className="text-[20px] font-semibold font-display">
          Ready for your qualification testing
        </strong>
        <span className="text-[16px] leading-[1.6] text-mx-muted">
          Parts supplied to support your API RP 19B system evaluations.
        </span>
      </li>
    </ul>
  </section>
  <section className="mt-[140px] mx-[120px] mb-0 py-[72px] px-20 bg-mx-accent rounded-[28px] flex justify-between items-center gap-12 tablet:px-6 tablet:mx-4 tablet:flex-wrap">
    <div className="flex flex-col gap-3 text-mx-ink">
      <h2 className="m-0 font-semibold text-[44px] leading-[1.1] font-display tablet:text-[32px]">
        Quote your next carrier run
      </h2>
      <p className="m-0 text-[18px] leading-[1.6] max-w-[620px]">
        Send your drawing, material spec and annual volume. NDA available before you share files.
      </p>
    </div>
    <Link to="/contact" className="inline-flex items-center min-h-14 px-8 py-0 rounded-[999px] bg-mx-ink text-white font-semibold text-[16px] whitespace-nowrap font-display">
      Request a quote
    </Link>
  </section>
  </>
);
export default OilGas;
